module.exports = "<dbm-edit class=\"user-container\" (save)=\"save()\" (cancel)=\"cancel()\">\n    <dbm-table *ngIf=\"displayedColumns && dataSource\" class=\"variables\"\n            [dataSource]=\"dataSource\"\n            [displayedColumns]=\"displayedColumns\"\n            (removeRowEvent)=\"removeRow($event)\"\n            (addRowEvent)=\"addNewRow($event)\">\n    </dbm-table>\n    <div class=\"validation-section\" *ngIf=\"!isValid\">\n        <div *ngFor=\"let validation of validationSave\">{{validation}}</div>\n    </div>\n</dbm-edit>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/project/variables/variables.component.html
// module id = 1807
// module chunks = 0